export default function isMobile(window, theme) {
  const windowWidth = window.innerWidth;
  const breakpointWidth = theme.breakpoints.values.md;
  return windowWidth < breakpointWidth;
}
